import { useEffect } from 'react';
/**
 * Checks if the browser's state matches the provided `mediaQuery`.
 *
 * Handles updating via the provided `callback` if the brower's state changes related to the media query.
 */
export function useMediaQuery(mediaQuery, callback) {
    useEffect(function () {
        if (window && window.matchMedia) {
            var mql_1 = window.matchMedia(mediaQuery);
            callback(mql_1.matches);
            var updateCallback_1 = function (e) {
                callback(e.matches);
            };
            // As usual web specs are dumb and we have two ways to add events listeners...
            // So addEventListener is correct and addListener is deprecated
            // Even TS doesn't know :)
            // @ts-ignore
            if (mql_1.addEventListener) {
                mql_1.addEventListener('change', updateCallback_1);
            }
            // @ts-ignore
            else if (mql_1.addListener) {
                mql_1.addListener(updateCallback_1);
            }
            return function () {
                // @ts-ignore
                if (mql_1.removeEventListener) {
                    mql_1.removeEventListener('change', updateCallback_1);
                }
                // @ts-ignore
                else if (mql_1.removeListener) {
                    mql_1.removeListener(updateCallback_1);
                }
            };
        }
    }, [callback, mediaQuery]);
}
//# sourceMappingURL=useMediaQuery.js.map